module.exports = __webpack_public_path__ + "img/voice.c3f815b3.png";